
import React from 'react';
import '../styles/Step.css';
import arrowim from '../assets/right-arrow.png'; // Import the arrow image
import { useTranslation } from 'react-i18next';

const Step = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar"; // Check if the current language is Arabic

  return (
    <div className="step-container">
      <h2 className="step-title">{t('stepTitle')}</h2>
      <div className="steps">
        {/* Step 1 */}
        <div className="step">
          <div className="step-number">1</div>
          <div className="step-content">
            <h3>{t('step1Title')}</h3>
            <p>{t('step1Description')}</p>
          </div>
        </div>

        {/* Arrow Image Between Step 1 and Step 2 */}
        <div className="ar-container">
          <img 
            src={arrowim} 
            alt={t('arrowAltText')} 
            className="arrow-image" 
            style={{ transform: isArabic ? "scaleX(-1)" : "none" }} 
          />
        </div>

        {/* Step 2 */}
        <div className="step">
          <div className="step-number">2</div>
          <div className="step-content">
            <h3>{t('step2Title')}</h3>
            <p>{t('step2Description')}</p>
          </div>
        </div>

        {/* Arrow Image Between Step 2 and Step 3 */}
        <div className="ar-container">
          <img 
            src={arrowim} 
            alt={t('arrowAltText')} 
            className="arrow-image" 
            style={{ transform: isArabic ? "scaleX(-1)" : "none" }} 
          />
        </div>

        {/* Step 3 */}
        <div className="step">
          <div className="step-number">3</div>
          <div className="step-content">
            <h3>{t('step3Title')}</h3>
            <p>{t('step3Description')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step;
